import { Stripe } from "@stripe/stripe-js";
import { createContext } from "react";

const StripeContext = createContext<Stripe | null>(null);

export default StripeContext;
